import { AccountDatasource } from './../../../user_app/datasources/account_datasource';
import { IDelegateResponder, IDelegateConstant, IDelegateController } from 'ui-ng-delegate';
import { ICommand } from 'core-ts-types';
import { Major } from '../../builders/major_builder';
import { DegreeCompletion } from '../../builders/degree_completion_builder';
import { DegreeCompletionRequirement } from '../../builders/degree_completion_requirement_builder';
import { IMemberDatasource, MemberDatasource } from './../../../global/datasources/member_datasource';
import { TransferDegreeCompletionQuery } from '../../queries/transfer_degree_completion_query';

export class TransferDegreeCompletionController {
  public major: Major;
  public studentId?: string;

  model: {
    config: IMemberDatasource;
  };

  constructor(
    private $scope: ng.IScope,
    private ngMemberDatasource: MemberDatasource,
    private ngTransferDegreeCompletionQuery: TransferDegreeCompletionQuery,
    private loadTransferMajorDegreeAuditCommand: ICommand,
    private ngAccountDatasource: AccountDatasource
  ) {
    this.major = $scope.major;
    this.studentId = $scope.studentId;
    if (_.isUndefined(this.degreeCompletion)) {
      loadTransferMajorDegreeAuditCommand(this.major.id, this.studentId);
    }
    this.model = {
      config: ngMemberDatasource.read()
    };
  }

  get degreeCompletion(): DegreeCompletion {
    const degreeCompletionId = this.studentId ? `${this.studentId}-${this.major.id}` : this.major.id;
    return this.ngTransferDegreeCompletionQuery.result[degreeCompletionId];
  }

  isCreditBasedCompletion(): boolean {
    if (!this.degreeCompletion) {
      return true;
    }

    return this.degreeCompletion.degree_completion_type == 'credit';
  }

  hasCourses(requirement: DegreeCompletionRequirement): boolean {
    return !_.isEmpty(requirement.transferred_classes);
  }

  hasAdditionalCourses(): boolean {
    return this.degreeCompletion && !_.isEmpty(this.degreeCompletion.additional_courses);
  }
}

class TransferDegreeCompletionDelegate {
  constructor(
    DelegateController: IDelegateController,
    transferDegreeCompletionDelegateConfiguration: IDelegateConstant
  ) {
    DelegateController(this, transferDegreeCompletionDelegateConfiguration);
  }
}

angular
  .module('capability-ng-transfer')
  .service('transferDegreeCompletionDelegate', TransferDegreeCompletionDelegate)
  .controller('ngTransferDegreeCompletionController', TransferDegreeCompletionController)
  .factory('transferDegreeCompletionDelegateConfiguration', (loadTransferMajorDegreeAuditCommand: ICommand) => {
    return {
      uniqueComponent: 'transfer-degree-completion',
      vocabulary: {
        updateDegreeCompletion: function(scope: any) {
          loadTransferMajorDegreeAuditCommand(scope.major.id, scope.studentId);
        }
      }
    };
  })
  .directive('transferDegreeCompletion', function(
    DelegateResponder: IDelegateResponder,
    transferDegreeCompletionDelegateConfiguration: IDelegateConstant
  ) {
    return {
      controller: 'ngTransferDegreeCompletionController',
      templateUrl: 'lib/transfer/components/degree_completion/degree_completion.html',
      controllerAs: '$ctrl',
      scope: {
        major: '<',
        studentId: '<?'
      },
      link: DelegateResponder(transferDegreeCompletionDelegateConfiguration, function(scope, element, attrs) {})
    };
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/degree_completion/degree_completion.ts